import React from "react";
import { Collapse } from "antd";
import { FormattedMessage } from "react-intl";
import AttachmentDetailsPanel from "./attachmentDetailsPanel";
const { Panel } = Collapse;

const EInvoiceDescription = props => {
  const {    
    documentIdInPreviewHandler,
    documentIdInPreview,
    previewDeadlinesHandler,
    isFullscreenOverlay
  } = props;
  const detailDocumentPanelStructure = [
    {
      header: function() {
        return (
          <div className="documentsCollapseHeader">
            <FormattedMessage id="documents.detail.linkedDocumentsSectionTitle" />
          </div>
        );
      },
      contentComponent: (
        <AttachmentDetailsPanel
          documentIdInPreviewHandler={documentIdInPreviewHandler}
          documentIdInPreview={documentIdInPreview}          
          isFullscreenOverlay={isFullscreenOverlay}
          previewDeadlinesHandler={previewDeadlinesHandler}
        />
      ),
      index: 0
    }
  ];
  const detailDocumentPanel = detailDocumentPanelStructure.map(panel => {
    return (
      <Panel
        header={panel.header()}
        className={
          "header-collapse-custom-panel-custom-panel attachmentInvoicePanel"
        }
        key={panel.index}
      >
        <div>{panel.contentComponent}</div>
      </Panel>
    );
  });
  return <Collapse bordered={false}>{detailDocumentPanel}</Collapse>;
};

export default EInvoiceDescription;
